import './ResourcePage.scss'

import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Col, Container, Row, Spinner } from 'react-bootstrap'
import parse from 'html-react-parser'

import Error from '../../common/error/Error'
import AccountMenu from '../../common/navigation/AccountMenu'
import { getResourcePageById } from '../../common/api/ResourcePages'

/**
 * Resource Page component. Used to pull post content straight from WordPress
 */
export default function ResourcePage({ setHeaderTitle, setReturnPath }) {
  const { resourceId } = useParams()
  const [error, setError] = useState()
  const [loading, setLoading] = useState(true)
  const [content, setContent] = useState()
  const [title, setTitle] = useState()

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)

    async function getResourcePageAsync() {
      const result = await getResourcePageById(resourceId)

      if (!result) {
        setError(
          'Unable to fetch resource page at this time. Please try again later.'
        )

        return
      }

      // Update header and return path
      setTitle(result?.title?.rendered)
      setHeaderTitle(result?.title?.rendered)
      setContent(result?.content?.rendered)
      setReturnPath(null)
      setLoading(false)
    }

    getResourcePageAsync()
  }, [resourceId, setHeaderTitle, setReturnPath])

  return (
    <>
      <Container className='resource-page-container'>
        <Error error={error} />
        <a href='#top' className='top-link'>
          <i className='bi bi-arrow-up-circle-fill'></i>
        </a>
        <Row xs={1} md={2}>
          {/* Sidebar panel for larger screens */}
          <Col md={4} className='mobile-hidden account-sidebar'>
            <AccountMenu />
          </Col>
          <Col md={8}>
            {loading ? (
              <Spinner
                animation='border'
                role='status'
                className='app-spinner'
                variant='primary'
                size='lg'
              >
                <span className='visually-hidden'>Loading...</span>
              </Spinner>
            ) : (
              <>
                <h1 id='top' className='title'>
                  {parse(title)}
                </h1>
                <div className='content-wrapper'>{parse(content)}</div>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </>
  )
}
